import { useEffect, useState } from "react";
import _ from "lodash";
import { Box, Collapse, Flex, FormControl, FormLabel, Heading, Button } from "@chakra-ui/react";
import { ChevronDownIcon, ChevronUpIcon, CopyIcon, DeleteIcon } from "@chakra-ui/icons";
import { GetProgramResopnse, Day } from "../../lib/types/programEdit";
import ReactSelect from "react-select";
import urlConstants from "../../lib/constants/url.constants";
import useApi from "../../lib/hooks/useApi";
import useToastNotification from "../../lib/hooks/useToastNotification";
import { ApiCommand } from "../../lib/Api";

type RestDayPlanProps = {
  weekIndex: number;
  dayIndex: number;
  day: Day;
  program: GetProgramResopnse;
  updateProgram: (updatedProgram: GetProgramResopnse) => void;
};

const { getRestDaysTitle: getRestDaystitleUrl } = urlConstants.restDays;

export const RestDayPlan = ({
  weekIndex,
  dayIndex,
  day,
  program,
  updateProgram,
}: RestDayPlanProps) => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [restDaysTitle, setRestDaysTitle] = useState<RestDayTitle[]>([]);
  const [selectedRestDayId, setSelectedRestDayId] = useState<string>("");
  const showToast = useToastNotification();

  const { sendRequest: getRestDaysTitleRequest } = useApi<RestDayTitle[]>();

  useEffect(() => {
    fetchRestDaysTitles();
    setSelectedRestDayId(
      typeof day.restDayId === "string"
        ? day.restDayId
        : day.restDayId?._id || "",
    );
  }, [day.restDayId]);

  const fetchRestDaysTitles = () => {
    getRestDaysTitleRequest({
      callback: (data: RestDayTitle[] | null, error: string | null) => {
        if (error) {
          showToast({
            title: "Failed",
            description: error,
            status: "error",
          });
          return;
        }
        if (!data) return null;
        setRestDaysTitle(data);
      },
      command: ApiCommand.GET,
      url: getRestDaystitleUrl,
    });
  };

  // const updateWeekRestDay = (updatedRestDay: WeekRestDay) => {
  //   const updatedProgram = _.cloneDeep(program);
  //   updatedProgram.weeks[weekIndex].restdays[restDayIndex] = updatedRestDay;
  //   updateProgram(updatedProgram);
  // };

  // const duplicateRestDay = () => {
  //   const updatedProgram = _.cloneDeep(program);
  //   const source = updatedProgram.weeks[weekIndex].restdays[restDayIndex];
  //   const clonedRestDay = _.cloneDeep(source);
  //   delete clonedRestDay._id;
  //   updatedProgram.weeks[weekIndex].restdays.push(clonedRestDay);
  //   updateProgram(updatedProgram);
  // };

  // const deleteRestDay = () => {
  //   const updatedProgram = _.cloneDeep(program);
  //   updatedProgram.weeks[weekIndex].restdays.splice(restDayIndex, 1);
  //   updateProgram(updatedProgram);
  // };

  const handleSelectChange = (restDayId: string) => {
    setSelectedRestDayId(restDayId);
    const updatedProgram = _.cloneDeep(program);
    updatedProgram.weeks[weekIndex].days[dayIndex].restDayId = restDayId;
    updateProgram(updatedProgram);
  };

  const restDayOptions = restDaysTitle.map(({ title, _id }) => ({
    label: title,
    value: _id,
  }));

  const selectedOption =
    restDayOptions.find((option) => option.value === selectedRestDayId) || null;

  return (
    <Box p={4} bg="primary.200" borderRadius="md" boxShadow="md" my={4}>
      <Flex justify="space-between" align="center">
        <Box flex="1" mr={5}>
          <Heading size="md" fontWeight="bold" whiteSpace="nowrap">
            {/* RESTDAY {restDayIndex + 1} */}
            Enjoy Yourself
          </Heading>
        </Box>
        {/* <Button
          backgroundColor="primary.300"
          leftIcon={<CopyIcon mr="-2" />}
          _hover={{ bg: "primary.500" }}
          mr={2}
          onClick={duplicateRestDay}
        />
        <Button
          backgroundColor="primary.300"
          leftIcon={<DeleteIcon mr="-2" />}
          _hover={{ bg: "primary.500" }}
          mr={5}
          onClick={deleteRestDay}
        /> */}
        <Button
          backgroundColor="primary.300"
          leftIcon={isCollapsed ? <ChevronDownIcon mr="-2" /> : <ChevronUpIcon mr="-2" />}
          onClick={() => setIsCollapsed(!isCollapsed)}
          _hover={{ bg: "primary.500" }}
        />
      </Flex>

       <Collapse in={!isCollapsed} animateOpacity>
        <FormControl>
          <FormLabel color="gray.600">Rest Day Template</FormLabel>
          <ReactSelect
            options={restDayOptions}
            value={selectedOption}
            onChange={(selected) => {
              if (!selected) return;
              handleSelectChange(selected.value);
            }}
            placeholder="Select rest day"
            menuPortalTarget={document.body}
            menuPosition="fixed"
          />
        </FormControl>
      </Collapse>
    </Box>
  );
};
